import type {BaseComponentPart, StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';

export interface WebSource {
  title: string;
  url: string;
  domain: string;
}

/** The pages a web search cited, shown under the reply that used them. */
export interface WebSourcesProps {
  sources: WebSource[];
}

export type WebSourcesComponentPart = BaseComponentPart<StreamComponentType.WEB_SOURCES, WebSourcesProps>;

export const MAX_STACKED_FAVICONS = 4;
